#import "../fragments/lead-fragment.graphql"

mutation UpdateLeadAssignee($lead: AssignLeadInputFieldInput!) {
    assignLead(input: {lead: $lead}) {
        lead {
            ...Lead
        }
        errors
    }
}
